import { render, staticRenderFns } from "./Theater.vue?vue&type=template&id=2b821800&scoped=true"
import script from "./Theater.vue?vue&type=script&lang=js"
export * from "./Theater.vue?vue&type=script&lang=js"
import style0 from "./Theater.vue?vue&type=style&index=0&id=2b821800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b821800",
  null
  
)

export default component.exports